import config from "../config"
const baseUrl = config.base_url + "z_sample_diary_type/"
export default {
    page: {
        url: baseUrl + "page",
        type: "get",
    },
    list: {
        url: baseUrl + "list",
        type: "get",
    },
    get: {
        url: baseUrl + "{id}",
        type: "get",
    },
    add: {
        url: baseUrl + "add",
        type: "post",
    },
    update: {
        url: baseUrl + "update",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete/{id}",
        type: "post",
    },
    deleteBatch: {
        url: baseUrl + "deleteBatch",
        type: "post",
    }
}
